export const backgroundOptions = [
  { 
    id: 'clean', 
    name: 'Clean Dark', 
    css: 'background-color: #050505;',
    wrapper: ''
  },
  { 
    id: 'aurora', 
    name: 'Aurora Borealis', 
    css: `
      background: #000000;
      position: relative;
      overflow: hidden;
    `, 
    wrapper: `
      <div style="position:fixed; inset:0; z-index:-1; filter:blur(80px); opacity:0.6;">
        <div style="position:absolute; top:-20%; left:-20%; width:70%; height:70%; background:radial-gradient(circle, rgba(79,70,229,0.8) 0%, transparent 70%); animation: drift 20s infinite alternate;"></div>
        <div style="position:absolute; bottom:-20%; right:-20%; width:70%; height:70%; background:radial-gradient(circle, rgba(236,72,153,0.8) 0%, transparent 70%); animation: drift 25s infinite alternate-reverse;"></div>
        <div style="position:absolute; top:40%; left:40%; width:80%; height:80%; background:radial-gradient(circle, rgba(6,182,212,0.8) 0%, transparent 70%); animation: drift 30s infinite alternate;"></div>
      </div>
      <style>@keyframes drift { from { transform: translate(0,0) rotate(0deg); } to { transform: translate(50px, 50px) rotate(20deg); } }</style>
    `
  },
  { 
    id: 'galaxy', 
    name: 'Deep Galaxy', 
    css: `
      background: linear-gradient(to bottom, #020105 0%, #090a0f 100%);
      overflow: hidden;
    `, 
    wrapper: `
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <style>
        #stars, #stars2, #stars3 { position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: -1; animation: animStar 150s linear infinite; }
        #stars { width: 1px; height: 1px; background: transparent; box-shadow: 1744px 122px #FFF , 134px 1321px #FFF , 92px 859px #FFF, 1843px 229px #FFF, 543px 229px #FFF, 1043px 929px #FFF, 243px 129px #FFF, 1143px 129px #FFF, 43px 1929px #FFF, 643px 529px #FFF, 1443px 429px #FFF; }
        #stars2 { width: 2px; height: 2px; background: transparent; box-shadow: 444px 1222px #FFF , 334px 121px #FFF , 92px 1859px #FFF, 143px 29px #FFF, 1543px 1229px #FFF, 143px 929px #FFF, 243px 1829px #FFF, 1143px 129px #FFF, 43px 929px #FFF; animation-duration: 100s; }
        #stars3 { width: 3px; height: 3px; background: transparent; box-shadow: 144px 222px #FFF , 1334px 1121px #FFF , 192px 159px #FFF; animation-duration: 200s; }
        @keyframes animStar { from { transform: translateY(0px); } to { transform: translateY(-2000px); } }
      </style>
    `
  },
  { 
    id: 'grid', 
    name: 'Cyber Grid', 
    css: `
      background-color: #050505;
      background-image: 
        linear-gradient(rgba(0, 255, 255, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 255, 255, 0.05) 1px, transparent 1px);
      background-size: 50px 50px;
      perspective: 500px;
    `, 
    wrapper: `
      <div style="position:fixed; inset:0; background: radial-gradient(circle at 50% 50%, transparent 0%, #000 90%); pointer-events: none; z-index: -1;"></div>
      <div style="position:fixed; inset:0; background: linear-gradient(180deg, transparent 0%, rgba(0,255,255,0.05) 50%, transparent 100%); height: 200%; width: 100%; animation: scan 10s linear infinite; pointer-events: none; z-index: -2;"></div>
      <style>@keyframes scan { 0% { transform: translateY(-50%); } 100% { transform: translateY(0%); } }</style>
    `
  },
  { 
    id: 'plasma', 
    name: 'Neon Plasma', 
    css: `
      background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
      background-size: 400% 400%;
      animation: gradientBG 15s ease infinite;
    `,
    wrapper: `
      <style>
        @keyframes gradientBG {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      </style>
    `
  },
  { 
    id: 'particles', 
    name: 'Golden Particles', 
    css: `background: #0f0c29;`,
    wrapper: `
      <div style="position:fixed; inset:0; z-index:-1; overflow:hidden;">
        <div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div><div class="firefly"></div>
      </div>
      <style>
        .firefly { position: absolute; width: 4px; height: 4px; background: #ffd700; border-radius: 50%; box-shadow: 0 0 10px #ffd700; animation: fly 15s infinite linear; opacity: 0; }
        .firefly:nth-child(1) { top: 10%; left: 10%; animation-delay: 0s; }
        .firefly:nth-child(2) { top: 20%; left: 80%; animation-delay: 2s; }
        .firefly:nth-child(3) { top: 80%; left: 20%; animation-delay: 4s; }
        .firefly:nth-child(4) { top: 50%; left: 50%; animation-delay: 6s; }
        .firefly:nth-child(5) { top: 90%; left: 90%; animation-delay: 1s; }
        @keyframes fly { 0% { opacity:0; transform:translate(0,0); } 20% { opacity:1; } 80% { opacity:1; } 100% { opacity:0; transform:translate(100px, -100px); } }
      </style>
    `
  },
  {
    id: 'matrix',
    name: 'The Matrix',
    css: `background: #000;`,
    wrapper: `
      <div style="position:fixed; inset:0; z-index:-1; font-family:monospace; color:#0f0; opacity:0.15; overflow:hidden; font-size: 20px; line-height: 20px; word-break: break-all;">
        01001010101101010010100100101010101010100101010101010101001010101
        10101010101010010101010101010101010100101010101010010101010101010
        01010101010101010100101010101010101101010101010101010101010101010
        10101010100101010101010101010101010101010101010101010101001010101
        01010010101010101010101010101010101010101010101010101010101010101
        10101010101010101010101010101010101010101010101010101010101010101
      </div>
    `
  },
  {
      id: 'hex',
      name: 'Hexagon Mesh',
      css: `
        background-color: #111;
        background-image: 
            linear-gradient(30deg, #222 12%, transparent 12.5%, transparent 87%, #222 87.5%, #222),
            linear-gradient(150deg, #222 12%, transparent 12.5%, transparent 87%, #222 87.5%, #222),
            linear-gradient(30deg, #222 12%, transparent 12.5%, transparent 87%, #222 87.5%, #222),
            linear-gradient(150deg, #222 12%, transparent 12.5%, transparent 87%, #222 87.5%, #222),
            linear-gradient(60deg, #333 25%, transparent 25.5%, transparent 75%, #333 75%, #333),
            linear-gradient(60deg, #333 25%, transparent 25.5%, transparent 75%, #333 75%, #333);
        background-size: 80px 140px;
        background-position: 0 0, 0 0, 40px 70px, 40px 70px, 0 0, 40px 70px;
      `,
      wrapper: ''
  },
  {
      id: 'noir',
      name: 'Film Noir',
      css: `background: #0a0a0a;`,
      wrapper: `
        <div style="position:fixed; inset:0; opacity:0.05; background-image: url('https://grainy-gradients.vercel.app/noise.svg'); filter: contrast(170%) brightness(100%);"></div>
        <div style="position:fixed; top:0; left:0; width:100%; height:100%; background: radial-gradient(circle at 50% 50%, transparent 0%, #000 120%);"></div>
      `
  },
  {
      id: 'circuit',
      name: 'Blue Circuit',
      css: `background-color: #000410;`,
      wrapper: `
        <div style="position: fixed; inset: 0; background-image: radial-gradient(#1e3a8a 1px, transparent 1px); background-size: 30px 30px; opacity: 0.3;"></div>
        <div style="position: fixed; inset: 0; background: repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(30, 58, 138, 0.1) 10px, rgba(30, 58, 138, 0.1) 20px);"></div>
      `
  },
  {
      id: 'retro',
      name: 'Retro Wave',
      css: `background: linear-gradient(to bottom, #2d1b4e 0%, #000000 100%);`,
      wrapper: `
        <div style="position:fixed; bottom:0; left:0; right:0; height:40vh; background: repeating-linear-gradient(to bottom, transparent 0%, transparent 2px, rgba(255,0,255,0.2) 3px); perspective: 100vh; transform: rotateX(60deg) scale(2);"></div>
        <div style="position:fixed; top:20%; left:50%; width:200px; height:200px; background: linear-gradient(to bottom, #ff00ff, #ffaa00); border-radius:50%; transform:translate(-50%, -50%); box-shadow: 0 0 40px #ff00ff; -webkit-mask-image: linear-gradient(to bottom, black 0%, black 50%, transparent 55%, transparent 60%, black 65%);"></div>
      `
  },
  {
      id: 'orb',
      name: 'Mystic Orb',
      css: `background: #000;`,
      wrapper: `
        <div style="position:fixed; inset:0; display:flex; align-items:center; justify-content:center;">
             <div style="width:60vw; height:60vw; background: conic-gradient(from 0deg, #ff0000, #00ff00, #0000ff, #ff0000); filter: blur(100px); opacity:0.2; animation: spin 10s linear infinite;"></div>
        </div>
        <style>@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }</style>
      `
  },
  {
    id: 'clouds', 
    name: 'Dark Clouds', 
    css: `background: #000;`,
    wrapper: `
       <div style="position:fixed; inset:0; z-index:-1; opacity:0.3; background: url('https://raw.githubusercontent.com/hudsonmarinho/header-cloud-animation/master/images/clouds_1.png') repeat-x; animation: cloud 80s linear infinite;"></div>
       <style>@keyframes cloud { 0% { background-position: 0 0; } 100% { background-position: 2000px 0; } }</style>
    `
  },
  {
    id: 'waves',
    name: 'Ocean Waves',
    css: `background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);`,
    wrapper: `
      <div style="position:fixed; bottom:0; left:0; width:100%; height:200px; z-index:-1; opacity:0.3;">
         <svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg"><path fill="#3b82f6" fill-opacity="1" d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,224C672,245,768,267,864,250.7C960,235,1056,181,1152,165.3C1248,149,1344,171,1392,181.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
      </div>
    `
  }
];